var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.25 5.38045C38.5184 7.26747 41.2325 9.98159 43.1195 13.25C45.0066 16.5184 46 20.226 46 24C46 27.774 45.0066 31.4816 43.1195 34.75C41.2325 38.0184 38.5184 40.7325 35.25 42.6195C31.9816 44.5066 28.274 45.5 24.5 45.5C20.726 45.5 17.0184 44.5066 13.75 42.6195C10.4816 40.7325 7.76747 38.0184 5.88045 34.75C3.99343 31.4816 3 27.774 3 24",
    stroke: "url(#paint0_linear_1649_93631)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1649_93631",
    x1: 11.3676,
    y1: 44.0441,
    x2: 27.9559,
    y2: 3.26471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1C311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4AE47",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingSpinner);
export default __webpack_public_path__ + "static/media/loading-spinner.0191ea2a2cc4c7385da3274339bf836c.svg";
export { ForwardRef as ReactComponent };